import { LeadEventType } from "./types";

export const getEventTypeLabel = (eventType: LeadEventType): string => {
  const labels: Record<LeadEventType, string> = {
    "lead.created": "Lead Creado",
    "lead.first-message-sent": "Primer Mensaje Enviado",
    "lead.first-message-delivered": "Primer Mensaje Entregado",
    "lead.first-message-read": "Primer Mensaje Leído",
    "lead.first-message-answered": "Primer Mensaje Respondido",
    "lead.redirected-to-human": "Redirigido a Humano",
    "lead.appointment-intention": "Intención de Cita",
    "lead.appointment-created": "Cita Creada",
    "lead.inactivated": "Lead Inactivado",
    "lead.discarded": "Lead Descartado",
    "lead.call-ended": "Llamada Finalizada",
    "lead.property-info-collected": "Captación: Información Recolectada",
    "lead.maintenance-requested": "Mantenimiento: Solicitud Creada",
  };
  return labels[eventType] || eventType;
};

export const getEventTypeDescription = (eventType: LeadEventType): string => {
  const descriptions: Record<LeadEventType, string> = {
    "lead.created":
      "Se dispara cuando se crea un nuevo lead en el sistema. Si el lead se originó en el CRM, este evento no se dispara",
    "lead.first-message-sent": "Se dispara cuando se envía el primer mensaje al lead",
    "lead.first-message-delivered": "Se dispara cuando el primer mensaje es entregado al lead",
    "lead.first-message-read": "Se dispara cuando el lead lee el primer mensaje",
    "lead.first-message-answered": "Se dispara cuando el lead responde al primer mensaje",
    "lead.redirected-to-human": "Se dispara cuando el lead es transferido a un agente humano",
    "lead.appointment-intention":
      "Se dispara cuando el lead expresa intención de agendar una cita (antes de que se cree la cita)",
    "lead.appointment-created": "Se dispara cuando se crea una cita para el lead",
    "lead.inactivated":
      "Se dispara cuando un lead cumple con el tiempo de inactividad sin haber agendado una cita o haber sido transferido a un agente humano",
    "lead.discarded": "Se dispara cuando un lead es descartado",
    "lead.call-ended": "Se dispara cuando finaliza una llamada con el lead",
    "lead.property-info-collected":
      "Se dispara cuando un lead de captación completa la recolección de información de la propiedad.",
    "lead.maintenance-requested":
      "Se dispara cuando un lead de mantenimiento crea una solicitud de mantenimiento.",
  };
  return descriptions[eventType] || "";
};
